const instructionsDataInitial = [
    {
        id: "tomato-sauce",
        name: "Tomato sauce",
        steps: [
            { text: "Preheat oven to _350°F_" },
            { text: "Crush #garlic#, chop #red onion#" },
            { text: "Heat #oil# and *garlic* in a dutch oven (or other large ovenproof pot) over medium heat, stirring until garlic is golden (about 4 minutes)" }, 
            { 
                text: "Add *onion*, #anchovies# (if using), and #red pepper flakes#, stirring often until onion is translucent (about 5 minutes)",
                timer: 5 
            },
            { text: "Add #tomato paste#, stirring often until darkened (about 2 minutes)" },
            { text: "Add #wine#, bring to a boil, and cook until wine is almost completely evaporated (about 1 minute)"},
            { text: "Add #tomatoes#, breaking up with your hands, and their juices"},
            { text: "Add #basil# and #oregano#, and stir to combine"},
            { text: "Swirl *1 ½ cups of water* in one empty tomato can, pour it into the other and swirl, then and add it to sauce" },
            { text: "Add *salt* (to taste)." },
            { 
                text: "Cover pot and transfer to oven (_350°F_). Cook for 2 and a half hours (give it a stir halfway through), until thick and tomatoes are browned on top and around edges of pot.",
                timer: 150
            },
            {
                text: "Let sauce cool, then stir with a whisk/fork (or use a food processor) to make it smoother"
            }
        ]
    },
    {
        id: "prep-eggplant",
        name: "Prep eggplant (slice & dry)",
        steps: [
            { text: "Peel #eggplant#, then slice lengthwise (½–¾ inch thick)" },
            { text: "Lightly season *eggplant slices* with *salt*. Put two layers of paper towels on the bottom of a baking sheet, add a layer of eggplant slices, top with more paper towels, and repeat as needed. Top with a final layer of paper towels." },
            { 
                text: "Put a second baking sheet on top, and add a weighted object (a heavy pot, etc.). Let eggplant sit for about an hour.",
                timer: 60,
                note: "What is the purpose of drying the eggplant slices? Eggplant juices are bitter, so the dish will taste better without them. Also, the drier eggplant will become more creamy when baked."
            }
        ]
    },
    {
        id: "bread-fry-eggplant",
        name: "Bread & fry eggplant slices",
        steps: [
            { text: "Combine #panko breadcrumbs#, #oregano#, #pepper#, and *parmesan* <span class='amount'>¾ cup</span> in a food processor (or by hand), and process until very finely ground. This is your breading mixture." },
            { text: "Setup three shallow bowls: 1 with #flour#, 1 with #eggs#, and 1 with *breading mixture*. Setup *eggplant slices* next to bowls, and a wire rack or baking sheet to put them on once coated." },
            { text: "One at a time: dredge eggplant slices in flour, dip in egg (allowing excess to drip off), then coat in breading mixture (packing all around, then shaking off excess). Place on wire rack or baking sheet." },
            { text: "Setup a baking sheet lined with paper towels, where you will place the eggplant slices once you have fried them." },
            { text: "Heat ⅔ cup *oil* in a large skillet (preferably cast iron) over medium-high" },
            { text: "Once hot, fry batches of *eggplant slices* for about 5 minutes (turning each slice once, halfway through). Transfer slices to paper towels, and immediately press with more paper towel to absorb oil. As needed, wipe out skillet and add the remaining ⅔ cup of *oil*." },
            { text: "Let cool, taste, and season with more *salt* if needed" }
        ]
    },
    {
        id: "assemble-bake",
        name: "Assemble & bake",
        steps: [
            { text: "Preheat oven to _350°F_" },
            { text: "Chop #fresh basil# and #fresh parsley#. Grate #mozzarella#." },
            { text: "In a bowl: combine basil, parsley, mozzarella, and #parmesan#. This will be your *cheese mixture*." },
            { text: "In baking dish: spread a layer of sauce (about 1 cup), top with a layer of cheese mixture, then a layer of eggplant slices. Repeat until finished with all eggplant slices (3-4 layers)" },
            { 
                text: "Cover baking dish with foil and bake for 1 hour (_350°F_)",
                timer: 60 
            },
            { text: "Remove from oven, remove foil, and add a layer of #fresh mozzarella# to top of dish." },
            {
                text: "Increase oven temperature to _425°F_, and bake (without foil) for an additional 15–20 minutes, until cheese is bubbling and browned in spots.",
                timer: 20
            },
            { text: "Let rest 30 minutes. Top with basil leaves just before serving." }
        ]
    }
]

function importAll(r) {
  return r.keys().map(r);
}

const allMedia = importAll(require.context('./media/instructions', true, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));
  
const mediaBySection = allMedia.reduce((acc, path) => {
    const sectionId = path.split('_')[0].split('/').pop(); // Extract section id from path
    if (!acc[sectionId]) { acc[sectionId] = [] } // Initialize array if it doesn't exist
    acc[sectionId].push(path); // Add path to array
    return acc;
}, {});

export const instructions = instructionsDataInitial.map(section => {
    // if there's an array of media for the given section
    if (mediaBySection[section.id]) {
        // add media array
        return { ...section, media: mediaBySection[section.id] };
    } else {
        return section;
    }
})